import { IConfig, Title } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getSelectionItems } from 'src/app/business/selectionitem-factory';
import { TenantConfigService } from './tenant-config.service';

@Injectable({ providedIn: 'root' })
export class TitlesService {
  constructor(private _tenantConfigService: TenantConfigService, private translate: TranslateService) {}

  private tenantConfig: IConfig;

  public async getSortedTitleSelectionItems() {
    return getSelectionItems(await this.getTitles(), 'patient.details.title.', this.translate, {
      sortAlphabetic: true,
    });
  }

  private async getTitles(): Promise<{ [Key: string]: number } | typeof Title> {
    await this.loadConfig();
    return this.tenantConfig.titles && Object.keys(this.tenantConfig.titles).length ? this.tenantConfig.titles : Title;
  }

  private async loadConfig(): Promise<void> {
    if (!this.tenantConfig) {
      this.tenantConfig = await this._tenantConfigService.getTenantConfig();
    }
    if (!this.tenantConfig) {
      window.logger.log('Cannot load tenant config.');
    }
  }
}
